import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_user/my-coaching/business/lead-magnets/leads",
)({
  staticData: { title: "Leads" },
  component: () => <Outlet />,
});
